// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.details-modal-wrapper .modal-body {
  width: 100%;
  padding: 16px 20px 20px;
}
.details-modal-wrapper .modal-title {
  width: 100%;
  text-align: left;
}
.details-modal-from-history .modal-title {
  text-align: center;
}
.details-modal-wrapper .modal-dialog {
  max-width: 960px;
}
.details-modal-wrapper .mt-3 {
  margin-top: 0 !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
